import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { FieldType, FormlyModule } from '@ngx-formly/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { DateHelperService } from '../../services/date-helper.service';
import { takeUntil } from 'rxjs';
import { injectDestroy } from 'ngxtension/inject-destroy';
import { InfoTooltipComponent } from '../info-tooltip.component';
import { isNaN } from 'lodash-es';

@Component({
  selector: 'formly-week-days-hours',
  template: `
    <div class="formly-field-week-time">
      <h3 class="mb-2">
        {{ props.label }}
        <app-info-tooltip [tooltip]="props.info"></app-info-tooltip>
      </h3>
      <div class="flex w-full flex-col md:flex-row gap-2 md:gap-4">
        @for (subField of field.fieldGroup; track $index) {
          <formly-field [field]="subField" [class]="subField.className" [formlyAttributes]="subField"></formly-field>
        }
      </div>
      @if (field.props.description) {
        <mat-hint class="inline-block mb-2">{{ field.props.description }}</mat-hint>
      }
    </div>
  `,
  imports: [
    ReactiveFormsModule,
    MatAutocompleteModule,
    FormlyModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    InfoTooltipComponent,
  ],
  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlyFieldWeekDaysHoursNumber extends FieldType implements OnInit {
  private destroy$ = injectDestroy();
  constructor() {
    super();
  }

  ngOnInit() {
    this.field.formControl.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(value => {
      this.calculateSummeryAndTotalHours(value);
    });
    this.calculateSummeryAndTotalHours(this.formControl.value);
  }

  calculateSummeryAndTotalHours(value) {
    let total = 0;
    const summary = [];
    DateHelperService.DAYS.forEach(day => {
      if (value[day] != undefined && !isNaN(Number(value[day]))) {
        total = total + Number(value[day]);
        if (Number(value[day]) !== 0) {
          summary.push(DateHelperService.dayNameToShortDayName(day) + ' ' + value[day]);
        }
      }
    });
    if (total !== this.field.formControl.get('total-hours')?.value) {
      this.field.formControl.get('total-hours').patchValue(total, { emitEvent: true });
    }
    if (summary.join(' | ') !== this.field.formControl.get('summary')?.value) {
      this.field.formControl.get('summary').patchValue(summary.join(' | '), { emitEvent: true });
    }
  }
}
